import { api } from "./client";

export type GroupSummary = {
  id: string;
  name: string;
  createdAt: string;
  memberCount: number;
  campaignCount: number;
};

export type GroupMember = {
  contactId: string;
  email: string;
  name: string | null;
  tier: "important" | "unimportant";
  vars: Record<string, unknown>;
};

export type GroupDetail = {
  id: string;
  name: string;
  createdAt: string;
  members: GroupMember[];
};

export function listGroups(): Promise<{ groups: GroupSummary[] }> {
  return api(`/groups`);
}

export function getGroup(id: string): Promise<{ group: GroupDetail }> {
  return api(`/groups/${id}`);
}

export function createGroup(name: string, contactIds: string[] = []): Promise<{ group: { id: string; name: string } }> {
  return api(`/groups`, { method: "POST", body: { name, contactIds } });
}

export function renameGroup(id: string, name: string): Promise<{ ok: true }> {
  return api(`/groups/${id}`, { method: "PATCH", body: { name } });
}

export function deleteGroup(id: string): Promise<{ deleted: number }> {
  return api(`/groups/${id}`, { method: "DELETE" });
}

export function addMembers(id: string, contactIds: string[]): Promise<{ added: number }> {
  return api(`/groups/${id}/members`, { method: "POST", body: { contactIds } });
}

export function removeMember(id: string, contactId: string): Promise<{ ok: true }> {
  return api(`/groups/${id}/members/${contactId}`, { method: "DELETE" });
}

export function updateMemberVars(
  id: string,
  contactId: string,
  vars: Record<string, string>,
): Promise<{ ok: true }> {
  return api(`/groups/${id}/members/${contactId}`, {
    method: "PATCH",
    body: { vars },
  });
}
